module.exports = __webpack_public_path__ + "img/ydss.4283bae4.png";